(() => {
 const desktop = matchMedia('(min-width:990px)');
 const tracked = new WeakSet();
 const scan = () => {
  document.querySelectorAll('body #MainContent .stellar-editorial--split:not(.stellar-editorial--brand-cards)').forEach(section => {
   if(tracked.has(section)) return;
   const wrap=section.querySelector(':scope > .stellar-editorial__wrap'),media=wrap?.querySelector(':scope > .stellar-editorial__media'),copy=wrap?.querySelector(':scope > .stellar-editorial__copy'),img=media?.querySelector(':scope > img');
   if(!img||!copy) return;
   tracked.add(section);
   let last='',frame;
   const check=() => {
    cancelAnimationFrame(frame);
    frame=requestAnimationFrame(() => {
     if(!section.isConnected) return;
     if(!desktop.matches){section.classList.remove('stellar-editorial--match-taller-copy');last='';return;}
     const key=Math.round(wrap.getBoundingClientRect().width)+':'+Math.round(copy.getBoundingClientRect().height);
     if(key===last||!img.complete) return;
     last=key;
     section.classList.remove('stellar-editorial--match-taller-copy');
     const imageHeight=img.getBoundingClientRect().height;
     if(imageHeight>0&&copy.getBoundingClientRect().height>imageHeight+1) section.classList.add('stellar-editorial--match-taller-copy');
    });
   };
   const observer=new ResizeObserver(check);observer.observe(wrap);observer.observe(copy);
   img.addEventListener('load',()=>{last='';check()});
   desktop.addEventListener('change',()=>{last='';check()});
   check();
  });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
 document.addEventListener('shopify:section:load',scan);
})();